import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useParams, useNavigate } from 'react-router-dom';
import MediaAlbum from './components/MediaAlbum';
import ResetPassword from './components/ResetPassword';
import './App.css';

const FUNCTIONS_BASE =
  process.env.REACT_APP_SUPABASE_FUNCTIONS_URL ||
  `${process.env.REACT_APP_SUPABASE_URL}/functions/v1`;

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Album for one plaque, addressed by the slug encoded in its QR code */}
          <Route path="/a/:slug" element={<MediaAlbum />} />
          {/* Link from the "reset your album password" email */}
          <Route path="/a/:slug/reset" element={<ResetPassword />} />
          {/* Pre-launch test plaques used /order/{shopify order id}; send them to the plaque's slug */}
          <Route path="/order/:orderId" element={<LegacyOrderRedirect />} />
          <Route path="/" element={<HomePage />} />
        </Routes>
      </div>
    </Router>
  );
}

function LegacyOrderRedirect() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch(`${FUNCTIONS_BASE}/album_get_media`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}` },
      body: JSON.stringify({ orderId }),
    })
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((data) => { if (!cancelled && data.slug) navigate(`/a/${data.slug}`, { replace: true }); else setFailed(true); })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, [orderId, navigate]);

  return (
    <div className="home-page">
      <div className="home-content">
        <h1>KeepsakeQR</h1>
        <p>{failed ? 'This link is no longer valid. Please scan the QR code on your plaque.' : 'Opening your album…'}</p>
      </div>
    </div>
  );
}

function HomePage() {
  return (
    <div className="home-page">
      <div className="home-content">
        <h1>KeepsakeQR</h1>
        <p>Scan your QR code to view your digital media album</p>
      </div>
    </div>
  );
}

export default App;
